export enum CampaignOutboundPhase {
  Idle = 0,
  Reserving = 1,
  Bcw = 2,
  Dialing = 3,
  Abandoned = 4,
  Exhausted = 5,
}
